import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaBookmark } from "react-icons/fa";
import { FaRegNewspaper } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import swal from "sweetalert2";
import PostModal from "../../Modals/PostModal";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropUtils";
import { getCroppedProfileImg } from "./CropUtilss";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import PostFeed from "../../GeneralFeedComponent/Post";
import LinkedInPost from "../Group/LinkedInPost";
import LinkedInPoll from "../Group/LinkedInPoll";
import EventPost from "../../GeneralFeedComponent/Event";

const Newsfeed = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const profile = useRef(null);
  const bg_profile = useRef(null);
  const [pimage, setPImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [inputKey, setInputKey] = useState(Date.now());
  const [isModalProfile, setIsModalProfile] = useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [experiencedata, setExperiencedata] = useState([]);
  const [experience, setExperience] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [introformData, setIntroFormData] = useState({
    name: "",
    email: "",
    add_name: "",
    gender: "",
    headline: "",
    position: "",
    industry: "",
    website: "",
    country: "",
    city: "",
    summary: "",
    profile_image: "",
    cover_image: "",
  });
  const [generalinfo, setGeneralInfo] = useState({})
  const [recommendations, setRecommendations] = useState([]);
  const [connectingUserId, setConnectingUserId] = useState(null);
  const [generalfeed, setGeneralFeed] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const perPage = 4;
  const currentUserRef = useRef({});
  const openModalProfile = () => {
    setIsModalProfile(true);
  };
  const closeModalProfile = () => {
    setIsModalProfile(false);
    setPreview(null);
    setSelectedImage(null);
  };
  useEffect(() => {
    getProfileData();
    getGeneralInfo();
    getRecommendations();
    // getGeneralFeed();
    getUserDetails();
  }, []);

  const getProfileData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `users`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      profile.current = response.data.data.profile_image;
      bg_profile.current = response.data.data.cover_image;
      setIntroFormData(response.data.data);
      setExperiencedata(response.data.data.experience);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getGeneralInfo = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `generalinfo`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if (response.status === 200) {
        setGeneralInfo(response.data.data);
      }
      
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }
  const getRecommendations = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `recommendations`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
 
      if (response.data.status === 200) {
        setRecommendations(response.data.data);
      }
      
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }
const getGeneralFeed = async (page = 1) => {
    if (isFetching) return;

    try {
      setIsFetching(true);
      const response = await axios.get(
        `${BaseUrl}generalfeed?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.data.status === 200) {
        const newFeed = response.data.data.feed;
       
        if (page === 1) {
          setGeneralFeed(newFeed);
        } else {
          setGeneralFeed((prev) => [...prev, ...newFeed]);
        }

        // Determine if more pages exist
        console.log(newFeed.length, perPage,'check');
        if (newFeed.length < perPage) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching feed:", error);
    } finally {
      setIsFetching(false);
    }
  };

  // Initial fetch
  useEffect(() => {
    setGeneralFeed([]);
    setPage(1);
    setHasMore(true);
    getGeneralFeed(1);
  }, []);

  // Scroll handler with threshold and debounce
  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        // Trigger when 300px from bottom
        if (
          scrollTop + windowHeight >= docHeight - 300 &&
          !isFetching &&
          hasMore
        ) {
          setPage((prev) => {
            const nextPage = prev + 1;
            getGeneralFeed(nextPage);
            return nextPage;
          });
        }
      }, 150); // Debounce delay
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);
  const getUserDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `userdetails`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      currentUserRef.current = {
        profile_image: response.data.data.profile_image,
        name: response.data.data.name,
      };
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const onCropProfileComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
    },
    []
  );
  const saveCroppedProfileImage = async (e) => {
    e.preventDefault();
    if (!pimage) return;
    const croppedImage = await getCroppedProfileImg(pimage, croppedArea);
    setPreview(croppedImage);
    setPImage(null);
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
    if (!validTypes.includes(file.type)) {
      swal.fire({
        icon: "error",
        title: "Invalid File Type",
        text: "Only JPG, PNG, WEBP, and GIF files are allowed.",
      });
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      swal.fire({
        icon: "warning",
        title: "File Too Large",
        text: "File size should be less than 2MB.",
      });
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const minWidth = 200;
      const minHeight = 200;
      const maxWidth = 1000;
      const maxHeight = 1000;

      if (img.width < minWidth || img.height < minHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Small",
          text: `Minimum dimensions required: ${minWidth}x${minHeight}px.`,
        });
        return;
      }

      if (img.width > maxWidth || img.height > maxHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Large",
          text: `Maximum allowed dimensions: ${maxWidth}x${maxHeight}px.`,
        });
        return;
      }

      setSelectedImage(file);
      setPImage(img.src);
      // setPreview(img.src);
    };
  };
  const handleProfileSubmit = async (event) => {
    event.preventDefault();
    if (!selectedImage) {
      swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select an image",
      });
      return;
    }
    const formData = new FormData();
    formData.append("profile", selectedImage);
    const token = Cookies.get("token");
    try {
      const response = await axios.post(BaseUrl + "updateprofile", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        setSelectedImage(null);
        closeModalProfile();
        await getProfileData(Cookies.get("userId"));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const handleConnect = async (id) => {
    setConnectingUserId(id);
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("request_to", id);
    try {
      const result = await axios.post(BaseUrl + `addtonetwork`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Connection request sent!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        
        setRecommendations((prev) =>
          prev.filter((user) => user.id !== id)
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to send request",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      console.log(error);
    }
    finally {
      setConnectingUserId(null);
    }
  };
  const renderPost = (post) => {
    console.log(currentUserRef.current);
    switch (post.type) {
      case "post":
        return <PostFeed key={post.id} postData={post} CurrentUser={currentUserRef.current} />;
      case "group_post":
        return <LinkedInPost key={post.id} postData={post} currentUser={currentUserRef.current}/>;
      case "group_poll":
        return <LinkedInPoll key={post.id} pollData={post} currentUser={currentUserRef.current} />;
      case "event":
        return <EventPost key={post.id} postData={post} CurrentUser={currentUserRef.current} />;
      default:
        return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          {/* <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0A66C2]"></div>*/}
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10 ">
          <div className=" container mx-auto flex flex-col lg:flex-row py-4 px-4 sm:px-6 lg:px-8">
            {/* Left Sidebar */}
            <div className="w-full lg:w-1/4 pt-4 pr-4 ">
              <div className="bg-white rounded-lg">
                <Link to="/user/userprofile">
                  <div className="relative">
                    {bg_profile.current ? (
                      <img
                        src={bg_profile.current}
                        alt="Creative design background"
                        className="w-full h-28 object-cover rounded-t-lg"
                      />
                    ) : (
                      <img
                        src={"/Images/cover-img.jpg"}
                        alt="Creative design background"
                        className="w-full h-28 object-cover rounded-t-lg"
                      />
                    )}

                    <div className="absolute bottom-4 left-4 transform translate-y-1/2">
                      {profile.current ? (
                        <img
                          src={profile.current}
                          alt="Profile of Erikson George"
                          className="size-24 rounded-full border-4 border-white"
                        />
                      ) : (
                        <div className="size-24 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-4xl">
                          {introformData.name.charAt(0)}
                        </div>
                      )}

                      <button
                        className="absolute bottom-2 left-[70px] bg-white rounded-full text-2xl text-blue-500"
                        onClick={openModalProfile}
                      >
                        <IoIosAddCircleOutline />
                      </button>
                    </div>
                    {isModalProfile && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10">
                        <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                          <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                            <h2 className="text-xl font-semibold">Add photo</h2>
                            <button
                              onClick={closeModalProfile}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <div className="px-5 py-4">
                            <form
                              onSubmit={handleProfileSubmit}
                              className="space-y-4"
                            >
                              <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
                                <input
                                  key={inputKey}
                                  type="file"
                                  id="image"
                                  accept="image/*"
                                  className="absolute w-full h-full opacity-0 cursor-pointer"
                                  onChange={handleImageChange}
                                />

                                {pimage && (
                                  <div className="relative w-full h-96 ">
                                    <Cropper
                                      image={pimage}
                                      crop={crop}
                                      zoom={zoom}
                                      aspect={4 / 4}
                                      onCropChange={setCrop}
                                      onZoomChange={setZoom}
                                      onCropComplete={onCropProfileComplete}
                                    />
                                    <button
                                      onClick={saveCroppedProfileImage}
                                      className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
                                    >
                                      Save Cropped Image
                                    </button>
                                  </div>
                                )}

                                {preview ? (
                                  <div className="flex flex-col items-center">
                                    <img
                                      src={preview}
                                      alt="Preview"
                                      className="mt-2 w-40 h-40 object-cover rounded-xl shadow-md border"
                                    />
                                  </div>
                                ) : !pimage ? (
                                  <>
                                    <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
                                      <FaCamera />
                                    </div>

                                    <span className="text-gray-500">
                                      Upload a photo
                                    </span>
                                    <p className="text-sm text-gray-600 mt-2">
                                      Allowed size range: <b>200x200px</b> to{" "}
                                      <b>1000x1000px</b>
                                    </p>
                                  </>
                                ) : null}
                              </div>
                              <button
                                type="submit"
                                className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
                              >
                                Upload Image
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pt-8 pb-4 px-6">
                    <div className=" ">
                      <div className="flex justify-between">
                        <div className="flex items-center space-x-4 ">
                          <h1 className="text-xl font-bold">
                            {introformData.name}
                          </h1>
                        </div>
                      </div>
                      <p className="text-sm text-gray-700">
                        {introformData.position}
                      </p>
                      <p className="text-[12px] text-gray-500">
                        {introformData.city}
                      </p>
                    </div>
                    <div className=" flex justify-between items-center mt-2">
                      <i className="fas fa-building text-2xl text-gray-500 "></i>
                      <p className="ml-2 text-gray-800 text-sm ">
                        {experiencedata ? experiencedata[0]?.company : ""}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
              <Link
                to="/user/networks"
                className=" flex justify-between p-4 border bg-white rounded-lg mt-2 hover:underline"
              >
                <div className="flex flex-col space-y-0">
                  <p className="text-[14px] ">Connections</p>
                  <p className=" text-[12px] text-gray-600">
                    Grow your network
                  </p>
                </div>
                <p className="text-[14px] text-blue-600">
                  {generalinfo.connection_count}
                </p>
              </Link>
              {/* <div className="p-4 border bg-white rounded-lg mt-2">
                <p className="text-[13px] text-gray-600 ml-1">
                  Network smarter with Premium
                </p>
                <div className="flex space-x-1">
                  <img
                    src="/Images/newsfeed/Premium.png"
                    alt="Premium"
                    className="size-6"
                  />
                  <p className="text-[15px] ">Try 1 month of premium for ₹0</p>
                </div>
              </div> */}
              <div className="flex space-y-3 text-lg flex-col p-4 border bg-white rounded-lg mt-2">
                <Link to={"/my-items/saved-post"}>
                  <div className="flex items-center  space-x-1">
                    <FaBookmark />
                    <p className="text-[15px] ">Saved items</p>
                  </div>
                </Link>
                <Link to="/groups">
                  <div className="flex items-center  space-x-1">
                    <FaPeopleGroup />
                    <p className="text-[15px] ">Groups</p>
                  </div>
                </Link>
                {/* <div className="flex items-center  space-x-1">
                  <FaRegNewspaper />
                  <p className="text-[15px] ">Newsletters</p>
                </div> */}
                <Link to="/events">
                  <div className="flex items-center  space-x-1">
                    <FaRegCalendarAlt />
                    <p className="text-[15px] ">Events</p>
                  </div>
                </Link>
              </div>
              {/* <div className=" text-center py-4 mt-8  border-t border-gray-300">
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-4">
              <Link to="#" className="hover:underline">
                About
              </Link>
              <Link to="#" className="hover:underline">
                Help Center
              </Link>
              <Link to="#" className="hover:underline">
                Privacy & Terms
              </Link>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Ad Choices
              </Link>
              <i className="fas fa-caret-down"></i>
              <Link to="#" className="hover:underline">
                Ad Choices
              </Link>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Advertising
              </Link>
              <Link to="#" className="hover:underline">
                Business Services
              </Link>
              <i className="fas fa-caret-down"></i>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Get the LinkedIn app
              </Link>
              <Link to="#" className="hover:underline">
                More
              </Link>
            </div>
            <div className="flex flex-wrap justify-center items-center mt-4">
              <img
                src="/Images/logo/ls-linked-logo.png"
                alt="LinkedIn logo"
                className="mr-2"
              />
              <span className="text-sm text-gray-600">
                LS-LinkedIn Corporation © 2025
              </span>
            </div>
          </div>  */}
            </div>

            {/* Main Content */}
            <div className="w-full lg:w-2/4 p-4">
              <div className="bg-white rounded-lg shadow p-4 mb-4">
                <div className="flex items-center">
                  {profile.current ? (
                    <img
                      src={profile.current}
                      alt="User profile"
                      className="rounded-full w-12 h-12"
                    />
                  ) : (
                    <img
                      src="/Images/newsfeed/ProfilePicture.png"
                      alt="User profile"
                      className="rounded-full w-12 h-12"
                    />
                  )}
                  <input
                    type="text"
                    placeholder="Start a post"
                    className="ml-4 w-full p-2 border rounded-full"
                    onClick={() => setModalOpen(true)}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  />
                  {modalOpen && (
                    <PostModal
                      modalOpen={modalOpen}
                      closeModal={() => setModalOpen(false)}
                    />
                  )}
                </div>
                <div className="flex justify-around mt-4 cursor-pointer">
                  <button
                    className="flex items-center text-gray-500 "
                    onClick={() => setModalOpen(true)}
                  >
                    <i className="fas fa-image mr-2"></i>Media
                  </button>

                  <button
                    className="flex items-center text-gray-500 "
                    onClick={() => navigate("/events")}
                  >
                    <i className="fas fa-calendar-alt mr-2"></i>Event
                  </button>

                  <button className="flex items-center text-gray-500">
                    <i className="fas fa-edit mr-2"></i>Write article
                  </button>
                </div>
              </div>

              {generalfeed.length > 0 ? (
                generalfeed.map((item) => renderPost(item))
              ) : (
                <p className="text-center text-gray-500">No posts to show.</p>
              )}
              {isFetching && (
                <div className="flex justify-center my-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                </div>
              )}
              {!hasMore && (
                <div className="text-center text-sm text-gray-500 py-4">
                  No more posts to show.
                </div>
              )}
            </div>

            {/* Right Sidebar */}
            <div className="w-full lg:w-1/4 p-4 p">
              {recommendations.length > 0 && (
                <div className="bg-white rounded-lg shadow p-4 mb-4">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">
                      Recommended for you
                    </h2>
                    <i className="fas fa-info-circle text-gray-400"></i>
                  </div>

                  <div className="space-y-4">
                    {recommendations.slice(0, 3).map((user) => (
                      <div key={user.id}>
                        <div className="flex items-center">
                          {user.profile ? (
                            <img
                              src={user.profile}
                              alt={`Profile picture of ${user.name}`}
                              className="w-12 h-12 rounded-full mr-4"
                            />
                          ) : (
                            <img
                              src="/Images/newsfeed/ProfilePic.png"
                              alt={`Profile picture of ${user.name}`}
                              className="w-12 h-12 rounded-full mr-4"
                            />
                          )}

                          <div className="flex-1">
                            <h3 className="text-sm font-semibold">
                              {user.name}
                            </h3>
                            <p className="text-xs text-gray-500">
                              {user.headline ||
                                ` ${user.mutual_count} mutual connection${
                                  user.mutual_count > 1 ? "s" : ""
                                }`}
                            </p>
                          </div>
                        </div>
                        <div className="flex flex-col items-end">
                          <button
                            className="flex items-center px-4 py-1 border border-blue-500 text-blue-500 rounded-full text-sm disabled:opacity-50"
                            onClick={() => handleConnect(user.id)}
                            disabled={connectingUserId === user.id}
                          >
                            {connectingUserId === user.id ? (
                              <>
                                <i className="fas fa-spinner fa-spin mr-2" />{" "}
                                Connecting...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-user-plus mr-2" /> Connect
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                    {recommendations.length > 3 && (
                      <div className="mt-4 text-center">
                        <Link
                          to="/user/networks"
                          className="text-sm text-gray-500 flex items-center justify-center"
                        >
                          See More <i className="fas fa-arrow-right ml-2"></i>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="bg-white rounded-lg shadow p-4 mb-4">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-semibold">LinkedIn News</h2>
                  <i className="fas fa-info-circle text-gray-400"></i>
                </div>
                <div className="space-y-2">
                  <div>
                    <h3 className="text-sm font-semibold">
                      Helping Gen Z upskill
                    </h3>
                    <p className="text-xs text-gray-500">
                      3d ago • 4,664 readers
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold">
                      India Inc woos high performers
                    </h3>
                    <p className="text-xs text-gray-500">
                      3d ago • 4,664 readers
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold">
                      Top newsletters of the week
                    </h3>
                    <p className="text-xs text-gray-500">
                      3d ago • 4,664 readers
                    </p>
                  </div>
                </div>
                <div className="flex flex-col justify-between items-center mt-4">
                  <p className="text-sm text-gray-500">
                    Show More{" "}
                    <i className="fas fa-arrow-right ml-2 text-gray-500"></i>
                  </p>
                </div>
              </div>
              <div className=" rounded-lg">
                <img
                  src="/Images/newsfeed/RightBannerCard.png"
                  alt="Digital Marketing"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Newsfeed;
